export default "__VITE_ASSET__ZL3V1jHp__"